import template from './typeahead-field.html';

const TypeaheadFieldComponent = {
    bindings: {
        clearAfterSelect: '<',
        displayProp: '<',
        emptyDisplayName: '<',
        hideLabel: '<',
        inputClass: '<',
        itemList: '<',
        label: '<',
        labelClass: '<',
        selectedItem: '<',
        setItem: '&'
    },
    template
};

export default TypeaheadFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/typeahead-field/typeahead-field-component.js